/**
 * Created by andrey on 04.12.2025
 */

Object.assign(Placements.ENTRIES, {
    importProgressWindow: {
        type: Placements.FREE_FOCUS | Placements.SYSTEM_FAULT,
        priority: 10002,
        filter: function () {
            return cleverapps.wantsImportProgress
                && !cleverapps.focusManager.findWindow(SignInWindow, ConflictWindow, CorruptedWindow)
                && cleverapps.Scenes.GetRunningScene().sceneComponent.isSceneReady();
        },
        action: function () {
            const action = (f) => {
                new ConflictWindow({
                    localSnapshot: connector.synchronizer.getLocalSnapshot(),
                    remoteSnapshot: cleverapps.wantsImportProgress.remoteSnapshot,
                    callback: () => {
                        const options = cleverapps.wantsImportProgress;
                        delete cleverapps.wantsImportProgress;

                        if (options) {
                            const newSession = options.newSession;
                            const remoteSnapshot = options.remoteSnapshot;
                            const callback = options.callback;

                            cleverapps.tutorial.stop();

                            connector.synchronizer.pull(newSession, remoteSnapshot);

                            cleverapps.Scenes.SceneRefresh();

                            callback();
                        }

                        f();
                    }
                });
            };

            if (cleverapps.focusManager.isFocused()) {
                cleverapps.focusManager.distract({ focus: "ImportProgressWindow", action });
            } else {
                cleverapps.focusManager.display({ focus: "ImportProgressWindow", action });
            }
        }
    },

    syncResolveConflict: {
        type: Placements.FREE_FOCUS | Placements.SYSTEM_FAULT,
        priority: 10001,
        filter: function () {
            if (connector.social.oneOf(connector.CRAZY) && cleverapps.user.guest && !connector.synchronizer.corrupted
                && (cleverapps.focusManager.isFocused() || !cleverapps.Scenes.GetRunningScene().introShown)) {
                return false;
            }

            // resolving right after load restarts the scene before its first frame; wait for the intro
            return [connector.SYNC_STATUS.CONFLICT, connector.SYNC_STATUS.PUSH, connector.SYNC_STATUS.PULL].includes(connector.synchronizer.status)
                && !cleverapps.focusManager.findFocus("ConflictResolve", "ConflictWindow", "CorruptedWindow", "ImportProgressWindow");
        },
        action: function () {
            const data = connector.synchronizer.conflictData || {};
            const localSnapshot = data.localSnapshot;
            const remoteSnapshot = data.remoteSnapshot;
            const newSession = data.newSession;

            cleverapps.focusManager.display({
                focus: "ConflictResolve",
                stack: true,
                actions: [
                    (f) => {
                        if (connector.SYNC_STATUS.CONFLICT === connector.synchronizer.status) {
                            connector.synchronizer.resolveConflict(localSnapshot, remoteSnapshot);
                        }

                        f();
                    },

                    (f) => {
                        if (connector.SYNC_STATUS.PUSH === connector.synchronizer.status) {
                            connector.synchronizer.push(newSession);
                        }

                        f();
                    },

                    (f) => {
                        delete connector.synchronizer.conflictData;

                        f();
                    },

                    (f) => {
                        if (connector.SYNC_STATUS.PULL !== connector.synchronizer.status) {
                            f();
                            return;
                        }

                        if (connector.social.oneOf(connector.CRAZY) && cleverapps.user.guest && !connector.synchronizer.corrupted) {
                            cleverapps.tutorial.stop();
                            cleverapps.focusManager.closeAllWindows();

                            connector.synchronizer.pull(newSession, remoteSnapshot);

                            cleverapps.Scenes.SceneRefresh();

                            f();
                            return;
                        }

                        cleverapps.focusManager.distract({
                            focus: "ConflictWindow",
                            actions: [
                                (f) => {
                                    cleverapps.tutorial.stop();
                                    cleverapps.focusManager.closeAllWindows();

                                    if (connector.synchronizer.corrupted) {
                                        cleverapps.focusManager.display({
                                            focus: "CorruptedWindow",
                                            stack: true,
                                            action: (f) => {
                                                new CorruptedWindow();
                                                cleverapps.focusManager.onceNoWindowsListener = f;
                                            }
                                        });
                                    }

                                    f();
                                },

                                (f) => {
                                    new ConflictWindow({
                                        localSnapshot,
                                        remoteSnapshot,
                                        callback: () => {
                                            if (connector.SYNC_STATUS.PULL === connector.synchronizer.status) {
                                                connector.synchronizer.pull(newSession, remoteSnapshot);

                                                cleverapps.Scenes.SceneRefresh();
                                            }

                                            f();
                                        }
                                    });
                                }
                            ]
                        });
                    }
                ]
            });
        }
    },

    cloudConflictWindow: {
        type: Placements.FREE_FOCUS | Placements.SYSTEM_FAULT | Placements.ONSHOW_OR_STARTUP,
        priority: 999,
        filter: function () {
            return cleverapps.dataLoader.needsReload && cleverapps.Scenes.GetRunningScene().sceneComponent.isSceneReady();
        },
        action: function () {
            const data = connector.cloudStorage.conflictData || {};
            const localSnapshot = data.localSnapshot;
            const remoteSnapshot = data.remoteSnapshot;

            cleverapps.focusManager.display({
                focus: "CloudConflictWindow",
                stack: true,
                action: function () {
                    new ConflictWindow({
                        localSnapshot,
                        remoteSnapshot,
                        callback: () => {
                            connector.platform.locationReload();
                        }
                    });
                }
            });
        }
    },

    syncSocialConnectWindow: {
        type: Placements.FREE_FOCUS | Placements.SYSTEM_FAULT,
        priority: 11,
        filter: function () {
            return connector.SYNC_STATUS.NEED_LOGIN === connector.synchronizer.status && !connector.synchronizer.needLoginRunned;
        },
        action: function () {
            cleverapps.focusManager.display({
                focus: "SynchronizerNeedLogin",
                actions: [
                    (f) => {
                        connector.synchronizer.needLoginRunned = true;

                        connector.social.invalidateAccessToken();

                        f();
                    },

                    (f) => {
                        if (!connector.social.isLoggedIn()) {
                            cleverapps.SocialManager.enforceLogin(f, {
                                withWindow: true,
                                errorMessage: Messages.get("SignInWindow.TryAgain")
                            });
                        } else {
                            f();
                        }
                    },

                    (f) => {
                        if (connector.social.isLoggedIn()) {
                            connector.synchronizer.checkSession();
                        }

                        f();
                    }
                ]
            });
        }
    },

    sync: {
        type: Placements.ONSHOW,
        action: function () {
            connector.synchronizer.checkSession();
        },
        interval: "30 seconds"
    }
});